<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline xblock-row">
          <input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="用户ID搜索" v-on:keydown.13="GetList(true)"
            v-model="uid" autocomplete="off" class="layui-input" />
        </div>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="手机号搜索" v-on:keydown.13="GetList(true)"
            v-model="phone" autocomplete="off" class="layui-input" />
        </div>
        <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach"
          v-on:click="GetList(true)"><i class="fa fa-search"></i></button>
        <div class="x-right xblock-row">
          <span class="x-right" v-if="count > 0" v-text="'共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'返佣：'+rebate_money+ '元　|　'"></span>
          <span class="x-right" v-text="'总额：'+total_money+ '元　|　'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>编号</th>
            <th v-if="role == 10">邀请人ID</th>
            <th>UID</th>
            <th>手机号</th>
            <th>名称</th>
            <th>支付金额</th>
            <th>返佣</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
            <td v-text="item.relation_id"></td>
            <td v-if="role == 10" v-text="item.uid"></td>
            <td v-text="item.c_id"></td>
            <td v-text="item.c_phone"></td>
            <td v-text="item.name"></td>
            <td v-text="item.pay_money"></td>
            <td v-text="item.money"></td>
            <td v-text="item.created_at"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laypage, laydate;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        te: 0,
        isLoding: true,
        ishow: "none",
        loading: false,
        role:30,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        id: null,
        uid:null,
        phone:null,
        item: null,
        page: 1,
        count: 0,
        page_num: 20,
        total_money: 0,
        rebate_money: 0,
        list: [],
        PackageType: [{
          id: 1,
          name: "VIP服务"
        }, {
          id: 2,
          name: "资源包"
        }, {
          id: 3,
          name: "空间扩容"
        }],
        PackageInfo: {
          shop_limit: 0,
          shop_count: 0
        }
      }
    },
    mounted() {
      self = this;
      let mid = self.$route.query.main_account_id
      let id = self.$route.query.shop_id
      let code = self.$route.query.code
      if (id) {
        self.store_shop_id(1, id, code);
      } else if (mid) {
        self.store_shop_id(2, mid, code);
      }
      self.role = localStorage.getItem("ExShopee_Role");

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        laydate = layui.laydate;

        //时间控件
        laydate.render({
          elem: '#order_date',
          range: true,
          trigger: 'click',
          done: function(value, date, endDate) {
            $("#order_date").val(value);
            self.GetList()
          }
        });

        //类型
        form.on('select(type_select)', function(data) {
          self.te = data.value;
          self.GetList();
        });

        form.render();

        // self.TestList();  //测试数据
        self.GetList();  //真实数据
        self.GetUserPackage();


      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      store_shop_id(te, id, code) {
        self.loading = true;
        let param = new URLSearchParams()
        if (te == 1) {
          param.append('shop_id', id)
        } else {
          param.append('main_account_id', id)
        }
        param.append('code', code)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_id/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ishow = "block";
            self.$router.push({
              path: "/Shop"
            });
            self.GetList();
            self.synchronize_orders(id); //同步订单
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      GetList() {
        self.list = [];

        //获取的结束时间自动加一天
        var t = $("#order_date").val();
        var start_time, end_time;
        if (t) {
        	self.getDate(t, function(s, e) {
        		start_time = s;
        		end_time = e;
        	})
        }

        let param = new URLSearchParams()
        if(start_time){
          param.append('start_time', start_time)
        }
        if(end_time){
          param.append('end_time', end_time)
        }
        if(self.uid){
          param.append('uid', self.uid)
        }
        if(self.phone){
          param.append('phone', self.phone)
        }
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_package_consumption_record/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            if (datas.page) {
              for (let i in datas.list) {
                datas.list[i].auth_time = self.timestampToTime(datas.list[i].auth_time)
              }
              if(datas.total_money){
                self.total_money = datas.total_money.toFixed(2);
              }
              if(datas.rebate_money){
                self.rebate_money = datas.rebate_money.toFixed(2);
              }
              self.list = datas.list;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            self.list = [];
            self.count = 0; //页数
            $('.pagebox').hide();
          }

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      GetUserPackage() {
        let param = new URLSearchParams()
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_package/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.PackageInfo = datas;
          }, false, true);

        }).catch(function(error) {
          console.log(error);
        })
      },
      get_authorization() {
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_authorization/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            window.open(datas);
            layer.closeAll();
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      synchronize_orders(id) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('shop_id', id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/synchronize_orders/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.ishow = "none";

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.Confirm.style = 1;
            self.Confirm.state = true;
            self.Confirm.txt = "订单导入成功，是否前往订单列表？"
          }, false, true);

        }).catch(function(error) {
          self.ishow = "none";
          self.loading = false;
          console.log(error);
        })
      },
      AddShop(title) {
        layer.open({
          type: 1,
          offset: '100px',
          title: "选择授权店铺类型",
          area: ['800px', '250px'],
          fixed: false, //不固定
          btn: ['店铺授权'],
          // btn: ['店铺授权', '查看我的店铺类型'],
          content: StoreAuthorization,
          success: function() {
            form.render();
          },
          yes: function(index, layero) {
            self.get_authorization();
          },
          btn2: function(index, layero) {
            window.open("https://exshopee.cn/privacy");
          }
        });
      },
      UpdateShop() {
        self.get_authorization();
      },
      ConfirmHint(te, item) {
        self.Confirm.style = 2;
        self.Confirm.state = true;
        if (te == 1) {
          self.Confirm.txt = "是否确认删除？"
        } else {
          self.Confirm.txt = "是否确认解除授权？"
        }
        self.item = item;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (self.Confirm.style == 1) {
          if (data.state) {
            console.log(data.state)
            self.Confirm.state = false;
            self.isLogin = true;
            localStorage.setItem("ExShopee_HistoryURL", "Order");
            self.GoToPage('/Order?te=0'); // 路由跳转
          }
        } else {
          if (data.state) {
            self.Confirm.state = false;
            let param = new URLSearchParams()
            param.append('id', self.item.id)
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/del_shop/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.GetList();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        }
      },
      TestList () {
        self.isLoding = false;
        self.count = 542;
        self.rebate_money = 6532;
        self.total_money = 16330;
        self.ShowPage(self, laypage, "GetList"); //分页
        $('.pagebox').show();
        self.list = [{
          c_id:949,
          c_phone:"15649032761",
          created_at:"2022-08-04 23:25:47",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L6ECWEK55YCS6"
        },{
          c_id:1028,
          c_phone:"15897961268",
          created_at:"2022-08-04 21:17:39",
          money:12.8,
          name:"2个店,一个月",
          pay_money:32,
          relation_id:"L5RHXO115YCUD"
        },{
          c_id:795,
          c_phone:"13202993566",
          created_at:"2022-08-04 19:18:15",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L6C82RJ35YCNW"
        },{
          c_id:862,
          c_phone:"13878712981",
          created_at:"2022-08-04 13:42:51",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L6BTCFOD5YCPR"
        },{
          c_id:1048,
          c_phone:"17708794146",
          created_at:"2022-08-04 10:45:03",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L6ABU5H95YCUX"
        },{
          c_id:416,
          c_phone:"13533421249",
          created_at:"2022-08-04 10:33:11",
          money:21.6,
          name:"6个店，一个月",
          pay_money:54,
          relation_id:"L694HWAL5YC29"
        },{
          c_id:937,
          c_phone:"18611195874",
          created_at:"2022-08-04 01:18:15",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L68WGWWR5YCRU"
        },{
          c_id:871,
          c_phone:"15040351888",
          created_at:"2022-08-04 00:31:22",
          money:19.2,
          name:"1个店,一季度",
          pay_money:48,
          relation_id:"L67BZSRK5YCQ0"
        },{
          c_id:994,
          c_phone:"15820402700",
          created_at:"2022-08-03 22:52:23",
          money:34.4,
          name:"2个店,一季度",
          pay_money:86,
          relation_id:"L66MWNF35YCTF"
        },{
          c_id:660,
          c_phone:"15906028331",
          created_at:"2022-08-03 20:42:43",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L64HBUNN5YCK5"
        },{
          c_id:508,
          c_phone:"15554445155",
          created_at:"2022-08-03 18:51:52",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L626WHI05YC4T"
        },{
          c_id:862,
          c_phone:"13878712981",
          created_at:"2022-08-03 14:42:11",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L61QWWPM5YCPR"
        },{
          c_id:1060,
          c_phone:"18927505647",
          created_at:"2022-08-03 13:22:14",
          money:19.2,
          name:"1个店,半年",
          pay_money:86,
          relation_id:"L5X744UE5YCV9"
        },{
          c_id:1064,
          c_phone:"18688682167",
          created_at:"2022-08-03 12:32:55",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L5W9V0SI5YCVD"
        },{
          c_id:940,
          c_phone:"19811948736",
          created_at:"2022-08-03 12:18:44",
          money:19.2,
          name:"2个店,一季度",
          pay_money:86,
          relation_id:"L5TO6YWJ5YCRX"
        },{
          c_id:739,
          c_phone:"15060600261",
          created_at:"2022-08-03 10:43:32",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L5S5GTMU5YCMC"
        },{
          c_id:1028,
          c_phone:"15897961268",
          created_at:"2022-08-03 08:42:33",
          money:7.2,
          name:"1个店,一个月",
          pay_money:18,
          relation_id:"L4XLMD0N5YC12"
        }]
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/RebateRecord.vue